import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Logger} from '@common-lib';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/concat';
import {saveAs} from 'file-saver/FileSaver';
import {ConfirmPopupComponent} from '../../components';
import {TranslationsService} from '../../pages-services';
import {SettingsService} from '../../pages-services/';
import {timer} from "rxjs/observable/timer";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-settings-translations',
    templateUrl: './settings-translations.component.html',
    styleUrls: ['./settings-translations.component.scss']
})
export class SettingsTranslationsComponent implements OnInit {

    requestStatus$: Observable<number>;
    timeInterval : number = 20000;
    sub: Subscription;
    countries = [];
    selectedLocale = 'en';
    editModalRef: BsModalRef;
    selectedRow: { key: string, value: string, new: boolean };
    searchTerm = '';
    deleteBefore = false;
    exportSelected = false;
    isExporting = false;
    isUploading = false;
    isRebuildCache = false;
    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        {key: 'key', title: ' '},
        {key: 'key', title: 'Key'},
        {key: 'value', title: 'Translation'},
        {key: 'actions', title: 'Actions'}
    ];
    data = [];
    rows = [];
    selected = new Set();
    originalRowForEdit: any = null;

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(
        private route: ActivatedRoute,
        private translationsService: TranslationsService,
        private translate: TranslateService,
        private toasterService: ToasterService,
        private settingsService: SettingsService,
        private modalService: BsModalService,
        private logger: Logger
    ) {
    }

    ngOnInit() {
        this.translationsService.getLocalizations().subscribe((data) => {
            this.countries = data.sort((a, b) => a.title.localeCompare(b.title));
            this.getList();
        });
      this.startInterval();
    }

    getList() {
        const locale = this.countries.find((l) => l.language === this.selectedLocale);
        if (locale) {
            this.translationsService.getList(locale.locales[0]).subscribe((data) => {
                this.data = data.translations;
                this.search();
            });
        }
    }

    localeChanged() {
        const locale = this.countries.find((l) => l.language === this.selectedLocale);
        if (locale) {
            this.translationsService.getList(locale.locales[0]).subscribe((data) => {
                this.data = data.translations;
                this.search();
            });
        }
    }


    eventEmitted($event) {
        switch ($event.event) {
            case 'onSelectAll':
                this.data.forEach((val, key) => {
                    if (this.selected.has(key)) {
                        this.selected.delete(key);
                    } else {
                        this.selected.add(key);
                    }
                });
                break;
            case 'onDoubleClick':
                this.editRow($event.value.row);
                break;
        }
    }


    showEditForm(template: TemplateRef<any>) {
        this.editModalRef = this.modalService.show(template);
    }


    editRow(row) {
        this.selectedRow = row;
        this.selectedRow = this.originalRowForEdit = Object.assign({}, row);
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    toggleRow({target: {checked}}, row) {
        const index = this.data.indexOf(row);
        if (checked) {
            this.selected.add(index);
        } else {
            this.selected.delete(index);
        }
    }

    isRowSelected(row) {
        return this.selected.has(this.data.indexOf(row));
    }

    saveTranslation() {
        this.editModalRef.hide();
        const locale = this.countries.find((l) => l.language === this.selectedLocale);
        if (locale) {
            this.translationsService.update(locale.locales[0], this.selectedRow.key, this.selectedRow.value).subscribe(async (result) => {
                this.getList();
                const successMessage = await this.translate.get('webpanel.translations.save.success_message').toPromise();
                this.toasterService.pop('success', '', successMessage);
            });
        }
    }

    search() {
        this.rows = this.data.filter((r) => r.key && r.value && (this.searchTerm.length === 0 ||
            r.key.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            r.value.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1));
        return this.rows;
    }

    addNew() {
        this.selectedRow = {
            'key': '',
            'value': '',
            'new': true
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeItem(item) {
        this.selectedRow = item;
        if (this.selectedRow) {
            this.confirmPopup.show();
        }
    }

    confirm(res) {
        if (res) {
            if (this.selectedRow) {
                this.translationsService.delete(this.selectedRow).subscribe(async (resp) => {
                    this.selectedRow = null;
                    const successMessage = await this.translate.get('webpanel.translations.delete.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                    this.getList();
                });
            }
        } else {
            this.selectedRow = this.originalRowForEdit;
            this.originalRowForEdit = null;
        }
    }

    decline() {
        this.selectedRow = this.originalRowForEdit;
        this.originalRowForEdit = null;
    }

    saveFile() {
        const locale = this.countries.find((l) => l.language === this.selectedLocale);
        if (locale) {
            this.isExporting = true;
            let res = [];
            this.selected.forEach(s => {
              res.push(this.data[s]);
              this.toggleRow({target: {checked: false}}, this.data[s]);
            });
            if(res.length > 0) {
              let r = res.map((r) => ({key: r.key, value: r.value})).sort((a, b) => a.key.localeCompare(b.key));
              this.saveToFileSystem(r);
            } else {
              this.translationsService.getList(locale.locales[0]).subscribe(response => {

                  if (this.exportSelected) {
                    let rows = response.translations.filter((r) => r.key && r.value &&
                      (r.key.includes('.fhel.') ||
                      r.key.includes('.fmel.') ||
                      r.key.includes('.fmxel.') ||
                      r.key.includes('.fhel-rhd.') ||
                      r.key.includes('.fmel-rhd.') ||
                      r.key.includes('.fmxel-rhd.')) &&
                      (this.searchTerm.length === 0 ||
                      r.key.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
                      r.value.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1));
                      let dd = rows.map((r) => {
                          if (r.key.includes('.fhel.')) {
                            r.key = r.key.replace('.fhel.', '.fhelectric.');
                          }
                          if (r.key.includes('.fmel.')) {
                            r.key = r.key.replace('.fmel.', '.fmelectric.');
                          }
                          if (r.key.includes('.fmxel.')) {
                            r.key = r.key.replace('.fmxel.', '.fmxelectric.');
                          }
                          if (r.key.includes('.fhel-rhd.')) {
                            r.key = r.key.replace('.fhel-rhd.', '.fhelectric-rhd.');
                          }
                          if (r.key.includes('.fmel-rhd.')) {
                            r.key = r.key.replace('.fmel-rhd.', '.fmelectric-rhd.');
                          }
                          if (r.key.includes('.fmxel-rhd.')) {
                            r.key = r.key.replace('.fmxel-rhd.', '.fmxelectric-rhd.');
                          }
                          return {key: r.key, value: r.value};
                      }).sort((a, b) => a.key.localeCompare(b.key));
                      this.saveToFileSystem(dd);
                  } else {
                      let dd = response.translations.map((r) => ({key: r.key, value: r.value})).sort((a, b) => a.key.localeCompare(b.key));
                      this.saveToFileSystem(dd);
                  }
              });

            }
        }
    }

    fileUpload({target}) {
        if (this.isUploading) {
            return;
        }
        this.isUploading = true;
        const fileField = target;
        const file = fileField.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            const result = JSON.parse(reader.result);
            const locale = this.countries.find((l) => l.language === this.selectedLocale);
            if (locale) {
              this.translationsService.uploadImport(locale.locales[0], result, this.deleteBefore).subscribe(async (response) => {
                  this.isUploading = false;
                  this.getList();
                  if (response.success) {
                      let successMessage = await this.translate.get('webpanel.translations.import.success_message').toPromise();
                      this.toasterService.pop('success', '', successMessage);
                  } else {
                      let errorMessage = await this.translate.get('webpanel.translations.import.error_message').toPromise();
                      this.toasterService.pop('error', '', errorMessage);
                  }
                  fileField.value = '';
              });
            }
        };
        reader.readAsText(file);
    }

    RebuildCache () {
        this.isRebuildCache = true;
        this.translationsService.rebuildCache().subscribe(() => {
          this.toasterService.pop('success', '', 'Done');
          this.isRebuildCache = false;
        });
    }

    saveFileAll () {
        let result = { translations: [] };
        let myObservables = new Array();
        const locales = this.countries
            .filter((l) => l.locales.length)
            .map(l => l.locales[0]);

        locales.forEach(l => {
            const subsc = this.translationsService.getList(l);
            myObservables.push(subsc);
        })

        Observable.concat(...myObservables)
            .subscribe((response: any) => {
                if (response.localeName && response.translations) {
                    result.translations.push({
                        locale: response.localeName,
                        translations: response.translations
                    })
                }
            },
                (error: any) => this.toasterService.pop('error', '', error));

        setTimeout(() => {
            if (result.translations.length) {
                this.isExporting = true;
                this.saveToFileSystem(result, true);
            }
        }, 8000);
    }

    fileUploadAll({target}) {
        if (this.isUploading) {
            return;
        }
        this.isUploading = true;
        const fileField = target;
        const file = fileField.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            let myObservables = new Array();
            const result = JSON.parse(reader.result);
            result.translations.forEach(t => {
                const locale = t.locale;
                const translations = t.translations;
                const subsc = this.translationsService.uploadImport(locale, translations);
                myObservables.push(subsc);
            });
            const count = result.translations.length;
            let current = 1;
            Observable.concat(...myObservables)
                .subscribe(async (response: any) => {
                    if (!response.success) {
                        let errorMessage = await this.translate.get('webpanel.translations.import.error_message').toPromise();
                        this.toasterService.pop('error', '', errorMessage);
                        return;
                    }
                    if (current === count) {
                        this.isUploading = false;
                        let successMessage = await this.translate.get('webpanel.translations.import.success_message').toPromise();
                        this.toasterService.pop('success', '', successMessage);
                    } else {
                        let successMessage = `${current} \\ ${count}`;
                        this.toasterService.pop('success', '', successMessage);
                    }
                    current++;
                },
                    (error: any) => this.toasterService.pop('error', '', error));
            fileField.value = '';
        };
        reader.readAsText(file);
    }

    private async saveToFileSystem(response, all = false) {
        const fileContent = JSON.stringify(response, null, 2);
        const blob = new Blob([fileContent], {type: 'text/plain'});
        let fileName;
        if (all) {
            fileName = 'translations-' + moment().format('YYYYMMDD-HHmm') + '.json';
        } else {
            fileName = 'translations-' + this.selectedLocale + '-' + moment().format('YYYYMMDD-HHmm') + '.json';
        }
        saveAs(blob, fileName);
        this.isExporting = false;
        const successMessage = await this.translate.get('webpanel.translations.export.success_message').toPromise();
        this.toasterService.pop('success', '', successMessage);
    }

    checkStatus() {
      this.settingsService.loadPublishVersionsList().subscribe((data) => {
        this.isRebuildCache = data.publishInProcess;
      });
    }

    startInterval() {
      this.requestStatus$ = timer(0, this.timeInterval).pipe();
      this.sub = this.requestStatus$.subscribe((data) => {
        this.checkStatus();
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/settings-translations/settings-translations.component.ts